import React from "react";

import { SelectEntityByType } from "../../modules/SelectEntityByType/SelectEntityByType";
import { FiltersFieldsTypes } from "../../modules/SelectEntityByType/constants";

export const TemplateSelectorsTypesField = ({ className, name = "type_code", label = "Selector Type", ...restProps }) => (
    <SelectEntityByType
        className={className}
        name={name}
        FieldsTypes={FiltersFieldsTypes.templateSelectorType}
        label={label}
        {...restProps}
    />
);
